import { render, staticRenderFns } from "./JiaQin.vue?vue&type=template&id=cd8d3d26&scoped=true&"
import script from "./JiaQin.vue?vue&type=script&lang=js&"
export * from "./JiaQin.vue?vue&type=script&lang=js&"
import style0 from "./JiaQin.vue?vue&type=style&index=0&id=cd8d3d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8d3d26",
  null
  
)

export default component.exports